import { ArrowSquareOut, House } from '@phosphor-icons/react';
import { Button } from 'client/components/Button';
import { ListItemFigure } from 'client/components/Other/ListItemFigure';
import { Subheader } from 'client/components/Subheader';

export const DashboardSubheader = () => (
  <Subheader
    title="Dashboard"
    subtitle="Overview & news"
    icon={<ListItemFigure icon={<House />} />}
    actions={
      <Button icon={<ArrowSquareOut />} href="https://docs.diploi.com/" external>
        Documentation
      </Button>
    }
  />
);
